/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {AlertService} from '../alert/alert.service';
import appUtil from '../../util/app.util';
import AppConstant from '../../constants/app.constant';
@Injectable({
  providedIn: 'root',
})
export class InstallService {
  deferredPrompt: any;

  constructor(private readonly alertSvc: AlertService) {}

  async showInstallPrompt(event: Event): Promise<void> {
    this.deferredPrompt = event;
    await this.alertSvc.show({
      header: AppConstant.APP_INSTALL_HEADER,
      message: AppConstant.APP_INSTALL_MESSAGE,
      cssClass: 'app-install-alert',
      buttons: [
        {
          text: 'Install',
          handler: () => {
            this.installPwa();
          },
          cssClass: 'app-installer-btn primary-btn',
        },
      ],
    });
  }

  private installPwa(): void {
    if (!appUtil.isEmpty(this.deferredPrompt)) {
      // Show the prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
      });
    }
  }

  async updateAppVersion(): Promise<void> {
    await this.alertSvc.show({
      header: AppConstant.APP_UPDATE_HEADER,
      message: AppConstant.APP_UPDATE_MSG,
      buttons: [
        {
          text: 'Install',
          handler: () => {
            window.location.reload();
          },
        },
      ],
    });
  }
}
